export const colHeaders = [
    'First Name',
    'Middle Name/Initial',
    'Last Name',
    'Email',
    'User Status'
];
